// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"7f9d52fc","415":"13035ae7","482":"19e0d05f","487":"76a6e128","636":"508e40a5","668":"19ed862b","812":"80a5db02"}[chunkId] + ".chunk.css";
};